// extracted by mini-css-extract-plugin
export default {"searchbox":"searchbox__ylcfC","clear":"clear__5vFOy"};